import axios from 'axios'
import { School } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface CreateSchoolRequest {
  displayName: string
  importNames?: string[]
  organization: string
}

export interface UpdateSchoolRequest extends Partial<CreateSchoolRequest> {
  _id: string
}

export interface SchoolsResponse {
  success: boolean
  data: School[]
}

export interface SchoolResponse {
  success: boolean
  data: School
}

export const getSchools = async (): Promise<School[]> => {
  const response = await api.get<SchoolsResponse>('/schools')
  return response.data.data
}

export const createSchool = async (
  schoolData: CreateSchoolRequest,
): Promise<School> => {
  const response = await api.post<SchoolResponse>('/schools', schoolData)
  return response.data.data
}

export const updateSchool = async (
  id: string,
  schoolData: Partial<CreateSchoolRequest>,
): Promise<School> => {
  const response = await api.put<SchoolResponse>(`/schools/${id}`, schoolData)
  return response.data.data
}

export const deleteSchool = async (id: string): Promise<void> => {
  await api.delete(`/schools/${id}`)
}
